/**
 * Quote validity (#2465, split out of the 991-line workshop form).
 */

import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { WorkshopSettings } from '@/types';
import { NumberField } from '@/components/common/NumberField';

interface Props {
  settings: WorkshopSettings;
  onChange: (settings: WorkshopSettings) => void;
}

export function WorkshopSectionQuotes({ settings, onChange }: Props) {
  const { t } = useTranslation('settings');

  return (
    <>
      {/* Quotes */}
      <Typography variant="h6" fontWeight={600} gutterBottom>
        {t('quotes.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('quotes.validityDesc')}
      </Typography>

      <Paper elevation={0} sx={{ p: 3, border: 1, borderColor: 'divider', mb: 4 }}>
        <NumberField
          fullWidth
          label={t('quotes.validityDays')}
          helperText={t('quotes.validityDaysHint')}
          value={settings.defaultQuoteValidityDays}
          min={1}
          max={365}
          onChange={(val) => {
            if (val !== null) onChange({ ...settings, defaultQuoteValidityDays: val });
          }}
          sx={{ maxWidth: 300 }}
        />
      </Paper>
    </>
  );
}
